import { WorkItemType } from "src/API/azureAPIs"
import { TypographyStandardTitleH2 } from "src/components/typography"
import { nestWorkItems, WorkItemList } from "../my_works/component.projectCard"
import { WorkItemTypeCentral } from "src/API/centralAPI"

type props = {
    projectName: string,
    TotalWorkItem: number,
    completedWorkItem: number,
    tasks: WorkItemType[]
}
type propsTaskVarient = {
    projectName: string,
    organization: string,
    // TotalWorkItem: number,
    // completedWorkItem: number,
    tasks: WorkItemTypeCentral[]
}

export function ProjectComponent(props: props) {

    const workItems = props.tasks.map(item => ({
        id: item.id,
        rev: item.rev,
        fields: item.fields,
        children: [],
        url: item.url,
        parentId: item.parentId || null,
        // startDate: item.fields["Custom.Starttime"] || null,
        // endDate: item.fields["Custom.Enddate"] || null,
        organization: ''
    }))

    return (
        <div className='border p-2 rounded-md grid grid-cols-1  w-full md:grid-cols-5 gap-2 gap-y-4'>
            <div className='w-full flex gap-2 md:col-span-3 '>
                <TypographyStandardTitleH2>{props.projectName}</TypographyStandardTitleH2>
            </div>
            <div className=' flex col-span-1 md:col-span-2'>
                <div className=' flex flex-col w-full place-items-end'>

                    <div className='flex'>
                        <TypographyStandardTitleH2>Total Work Item: </TypographyStandardTitleH2>
                        <p className=" pl-1">{props.TotalWorkItem}</p>
                    </div>
                    <div className='flex'>
                        <TypographyStandardTitleH2>Completed Work Item: </TypographyStandardTitleH2>
                        <p className="pl-1">{props.completedWorkItem}</p>
                    </div>
                </div>
            </div>
            <WorkItemList
                workItems={workItems}
            />
        </div>
    )

}
export function ProjectComponentTaskVarient(props: propsTaskVarient) {

    // const workItems = props.tasks.map(item => ({
    //     id: item.id,
    //     rev: item.rev,
    //     fields: item.fields,
    //     children: [],
    //     url: item.url,
    //     parentId: item.parentId || null,
    //     startDate: item.fields["Custom.Starttime"] || null,
    //     endDate: item.fields["Custom.Enddate"] || null,
    //     organization: props.organization
    // }))

    const nestedWorkItems = nestWorkItems(
        props.tasks?.filter((item) => item.revisions?.[item.revisions.length - 1]?.fields['System.WorkItemType'] === 'Issue' || item.revisions?.[item.revisions.length - 1]?.fields['System.WorkItemType']  === 'Task')
          .map((item) => {
           
            return {
              id:item.id,
              rev: item.revisions?.[item.revisions.length - 1]?.rev,
              fields: item.revisions?.[item.revisions.length - 1]?.fields,
              url:'',
              organization: item.organizationId || '',
              parentId: item.revisions?.[item.revisions.length - 1]?.fields["System.Parent"] || null,
            } ;
          }) || []);

    return (
        <div className='border p-2 rounded-md grid grid-cols-1  w-full md:grid-cols-4 gap-2 gap-y-4 bg-white dark:bg-gray-700 rounded'>
            <div className='w-full flex gap-2 md:col-span-2 '>
                <TypographyStandardTitleH2>{props.projectName}</TypographyStandardTitleH2>
            </div>
            <div className=' flex col-span-1 md:col-span-2'>
                <div className=' flex flex-col w-full place-items-end'>

                    <div className='flex'>
                        <TypographyStandardTitleH2>Total Work Item: </TypographyStandardTitleH2>
                        <p className=" pl-1">{props.tasks.length}</p>
                    </div>
                </div>
            </div>
            <div className=" flex flex-col col-span-full">
                <WorkItemList
                    workItems={nestedWorkItems}
                />
            </div>
        </div>
    )

}